// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/company_contract.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/company_contract.proto.
 */
export const file_api_proto_v1_company_contract: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_wrappers]);

/**
 * プラン定義マスタ 1 件（service_plans テーブル）。契約作成フォームの選択肢に使う
 *
 * @generated from message api_proto.v1.ServicePlanItem
 */
export type ServicePlanItem = Message<"api_proto.v1.ServicePlanItem"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * プラン種別 crm / ai_app（go/models/plan.go の PlanType 定数）
   *
   * @generated from field: string plan_type = 2;
   */
  planType: string;

  /**
   * 段階 free / light / standard / premium / enterprise（go/models/plan.go の PlanTier 定数）
   *
   * @generated from field: string tier = 3;
   */
  tier: string;

  /**
   * 表示名（例: CRMライト）
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * アカウント数上限（CRM系のみ。未設定(null)=上限なし/対象外）
   *
   * @generated from field: google.protobuf.Int64Value max_active_staffs = 5;
   */
  maxActiveStaffs?: bigint;

  /**
   * 月払い時の月次付与クレジット（AI系のみ。未設定(null)=対象外）
   *
   * @generated from field: google.protobuf.Int64Value monthly_grant_credits = 6;
   */
  monthlyGrantCredits?: bigint;

  /**
   * 年払い時の期首一括付与クレジット（AI系のみ。未設定(null)=対象外）
   *
   * @generated from field: google.protobuf.Int64Value yearly_grant_credits = 7;
   */
  yearlyGrantCredits?: bigint;

  /**
   * このプランの契約は数量（業務管理ならアカウント上限、営業支援なら付与クレジット）の入力が必須か。
   * プランが標準の数量を持たない（エンタープライズ）とき真。DBの列ではなく、サーバーが
   * models.Plan.HasStandardQuantity から毎回計算して返す（判定の規則をクライアントに複製しないため）
   *
   * @generated from field: bool requires_contract_quantity = 8;
   */
  requiresContractQuantity: boolean;

  /**
   * このプランの契約が数量（業務管理ならアカウント上限の上書き値、営業支援なら周期あたりの付与量）を持てるか。
   * 偽は営業支援の無料プラン（標準の付与量が0＝付与しない）で、契約の付与量はサーバーが拒否する。
   * 画面は偽なら数量の欄を出さず、値を送らない。サーバーがmodels.Plan.AcceptsContractQuantityから毎回計算して返す
   *
   * @generated from field: bool accepts_contract_quantity = 9;
   */
  acceptsContractQuantity: boolean;
};

/**
 * Describes the message api_proto.v1.ServicePlanItem.
 * Use `create(ServicePlanItemSchema)` to create a new message.
 */
export const ServicePlanItemSchema: GenMessage<ServicePlanItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 0);

/**
 * @generated from message api_proto.v1.ListServicePlansRequest
 */
export type ListServicePlansRequest = Message<"api_proto.v1.ListServicePlansRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListServicePlansRequest.
 * Use `create(ListServicePlansRequestSchema)` to create a new message.
 */
export const ListServicePlansRequestSchema: GenMessage<ListServicePlansRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 1);

/**
 * @generated from message api_proto.v1.ListServicePlansResponse
 */
export type ListServicePlansResponse = Message<"api_proto.v1.ListServicePlansResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.ServicePlanItem plans = 1;
   */
  plans: ServicePlanItem[];
};

/**
 * Describes the message api_proto.v1.ListServicePlansResponse.
 * Use `create(ListServicePlansResponseSchema)` to create a new message.
 */
export const ListServicePlansResponseSchema: GenMessage<ListServicePlansResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 2);

/**
 * 契約状態遷移のイベント履歴 1 件（company_contract_events テーブル）
 *
 * @generated from message api_proto.v1.CompanyContractEventItem
 */
export type CompanyContractEventItem = Message<"api_proto.v1.CompanyContractEventItem"> & {
  /**
   * created / canceled / renewed / plan_changed / grant_credits_changed など（go/models/company_contract.go の ContractEvent* 定数）
   *
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * 変更内容のスナップショット（JSON 文字列。未設定は空文字）
   *
   * @generated from field: string payload = 2;
   */
  payload: string;

  /**
   * 操作した管理者名。バッチ・システム起因は空文字
   *
   * @generated from field: string actor_admin_name = 3;
   */
  actorAdminName: string;

  /**
   * 発生日時（RFC3339）
   *
   * @generated from field: string created = 4;
   */
  created: string;
};

/**
 * Describes the message api_proto.v1.CompanyContractEventItem.
 * Use `create(CompanyContractEventItemSchema)` to create a new message.
 */
export const CompanyContractEventItemSchema: GenMessage<CompanyContractEventItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 3);

/**
 * 企業の契約 1 本（company_contracts テーブル）。プラン情報・イベント履歴を nested で含む
 *
 * @generated from message api_proto.v1.CompanyContractItem
 */
export type CompanyContractItem = Message<"api_proto.v1.CompanyContractItem"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ULID
   *
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * 表示名（例: CRMライト）
   *
   * @generated from field: string plan_name = 3;
   */
  planName: string;

  /**
   * プラン種別 crm / ai_app
   *
   * @generated from field: string plan_type = 4;
   */
  planType: string;

  /**
   * 段階 free / light / standard / premium / enterprise
   *
   * @generated from field: string plan_tier = 5;
   */
  planTier: string;

  /**
   * 支払いサイクル yearly / monthly（go/models/company_contract.go の BillingCycle 定数）
   *
   * @generated from field: string billing_cycle = 6;
   */
  billingCycle: string;

  /**
   * 契約状態 active / canceled（go/models/company_contract.go の ContractStatus 定数）
   *
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * 現契約期間の開始日（YYYY-MM-DD）
   *
   * @generated from field: string starts_on = 8;
   */
  startsOn: string;

  /**
   * 現契約期間の終了日（YYYY-MM-DD）。満了時は自動更新で次期間へ延長される
   *
   * @generated from field: string ends_on = 9;
   */
  endsOn: string;

  /**
   * 解約日時（RFC3339）。未解約は空文字
   *
   * @generated from field: string canceled_at = 10;
   */
  canceledAt: string;

  /**
   * Admin メモ
   *
   * @generated from field: string note = 11;
   */
  note: string;

  /**
   * 状態遷移のイベント履歴（発生日時降順）
   *
   * @generated from field: repeated api_proto.v1.CompanyContractEventItem events = 12;
   */
  events: CompanyContractEventItem[];

  /**
   * アカウント上限の上書き値（単位は人）。未設定=上書きなしでプラン標準値（ServicePlanItem.max_active_staffs）を使う。
   * 業務管理（crm）契約でのみ意味を持つ（decisions.md決定33・決定89(e)）
   *
   * @generated from field: optional int64 max_active_staffs_override = 14;
   */
  maxActiveStaffsOverride?: bigint;

  /**
   * 支払い周期1回あたりの付与クレジット（年払いなら1年あたり、月払いなら1か月あたり）。
   * 営業支援契約でのみ意味を持つ。未設定=プランの標準値を使う
   *
   * @generated from field: optional int64 grant_credits_per_period = 15;
   */
  grantCreditsPerPeriod?: bigint;

  /**
   * 実効のアカウント上限（契約の上書き値、無ければプランの標準値。staffcapacity.ContractLimit）。
   * 業務管理契約で上限があるときだけ設定される。画面はこれを表示し、自分で組み立てない
   *
   * @generated from field: optional int64 effective_max_active_staffs = 16;
   */
  effectiveMaxActiveStaffs?: bigint;

  /**
   * 実効の支払い周期あたり付与クレジット（契約の値、無ければプランの標準値。models.ContractGrantForCycle）。
   * 営業支援契約でだけ設定される（無料は0）。画面はこれを表示し、自分で組み立てない
   *
   * @generated from field: optional int64 effective_grant_credits_per_period = 17;
   */
  effectiveGrantCreditsPerPeriod?: bigint;

  /**
   * この契約のプランが数量の入力を必須とするか（ServicePlanItem.requires_contract_quantity と同じ値）。
   * 真なら、上限・付与量を「外す」操作はサーバーが拒否する
   *
   * @generated from field: bool requires_contract_quantity = 18;
   */
  requiresContractQuantity: boolean;

  /**
   * この契約のプランが契約の数量を持てるか（ServicePlanItem.accepts_contract_quantityと同じ値）。
   * 偽なら、数量（付与量）を変更する操作はサーバーが拒否する
   *
   * @generated from field: bool accepts_contract_quantity = 19;
   */
  acceptsContractQuantity: boolean;

  /**
   * 解約予定日（YYYY-MM-DD）。「この日まで使え、翌日から解約済み（閲覧のみ）になる」という意味で、
   * ends_on と同じ読み方（当日中は使えて翌日に失効）。予約なしは空文字。
   * 予約中も status は active のまま。実行は日次ジョブ（契約メンテナンス。毎日01:00）が行い、
   * 実行後も値は残す。即時解約（CancelCompanyContract）は値を消す（canceled かつ値あり＝予定どおりの解約）。
   * openspec/changes/admin-contract-cancel-schedule
   *
   * @generated from field: string cancel_scheduled_on = 20;
   */
  cancelScheduledOn: string;
};

/**
 * Describes the message api_proto.v1.CompanyContractItem.
 * Use `create(CompanyContractItemSchema)` to create a new message.
 */
export const CompanyContractItemSchema: GenMessage<CompanyContractItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 4);

/**
 * @generated from message api_proto.v1.ListCompanyContractsRequest
 */
export type ListCompanyContractsRequest = Message<"api_proto.v1.ListCompanyContractsRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.ListCompanyContractsRequest.
 * Use `create(ListCompanyContractsRequestSchema)` to create a new message.
 */
export const ListCompanyContractsRequestSchema: GenMessage<ListCompanyContractsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 5);

/**
 * @generated from message api_proto.v1.ListCompanyContractsResponse
 */
export type ListCompanyContractsResponse = Message<"api_proto.v1.ListCompanyContractsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CompanyContractItem contracts = 1;
   */
  contracts: CompanyContractItem[];
};

/**
 * Describes the message api_proto.v1.ListCompanyContractsResponse.
 * Use `create(ListCompanyContractsResponseSchema)` to create a new message.
 */
export const ListCompanyContractsResponseSchema: GenMessage<ListCompanyContractsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 6);

/**
 * 契約の新規作成。ends_on は billing_cycle からサーバ側で算出するためリクエストに含めない
 *
 * @generated from message api_proto.v1.CreateCompanyContractRequest
 */
export type CreateCompanyContractRequest = Message<"api_proto.v1.CreateCompanyContractRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ULID
   *
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * yearly / monthly
   *
   * @generated from field: string billing_cycle = 3;
   */
  billingCycle: string;

  /**
   * 契約開始日（YYYY-MM-DD）
   *
   * @generated from field: string starts_on = 4;
   */
  startsOn: string;

  /**
   * @generated from field: string note = 5;
   */
  note: string;

  /**
   * 契約の数量。契約の値はプランの標準値より優先し、未指定ならプランの標準値を使う。
   * プランが標準の数量を持たない（ServicePlanItem の該当項目が未設定。エンタープライズ）ときは、種別に応じた数量が必須:
   * 営業支援は grant_credits_per_period（1以上`models.MaxGrantCreditsPerPeriod`まで）、業務管理は max_active_staffs_override（1以上。標準があるプランでは0以上）。
   * 種別違い（営業支援に上限、業務管理に付与量）は入力エラー
   *
   * @generated from field: optional int64 grant_credits_per_period = 6;
   */
  grantCreditsPerPeriod?: bigint;

  /**
   * @generated from field: optional int64 max_active_staffs_override = 7;
   */
  maxActiveStaffsOverride?: bigint;
};

/**
 * Describes the message api_proto.v1.CreateCompanyContractRequest.
 * Use `create(CreateCompanyContractRequestSchema)` to create a new message.
 */
export const CreateCompanyContractRequestSchema: GenMessage<CreateCompanyContractRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 7);

/**
 * 契約のプラン変更（同一 plan_type 内の tier / 支払いサイクル変更）。
 * 旧契約を canceled にして新契約行を作る運用のため、変更後の新しい契約 ID は返さない
 * （一覧は ListCompanyContracts で取り直す想定）
 *
 * @generated from message api_proto.v1.ChangeCompanyContractPlanRequest
 */
export type ChangeCompanyContractPlanRequest = Message<"api_proto.v1.ChangeCompanyContractPlanRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ULID（変更対象の現行契約）
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * ULID
   *
   * @generated from field: string new_plan_id = 3;
   */
  newPlanId: string;

  /**
   * yearly / monthly
   *
   * @generated from field: string billing_cycle = 4;
   */
  billingCycle: string;

  /**
   * 変更先のプランに対する契約の数量（CreateCompanyContractRequest と同じ規則）。付与量は現契約から引き継がない
   * （支払いサイクルや段階が変わると意味が変わるため）。アカウント上限の上書きは、未指定なら
   * 同じプランで支払いサイクルだけを変えるときに限り現契約から引き継ぐ
   *
   * @generated from field: optional int64 grant_credits_per_period = 5;
   */
  grantCreditsPerPeriod?: bigint;

  /**
   * @generated from field: optional int64 max_active_staffs_override = 6;
   */
  maxActiveStaffsOverride?: bigint;
};

/**
 * Describes the message api_proto.v1.ChangeCompanyContractPlanRequest.
 * Use `create(ChangeCompanyContractPlanRequestSchema)` to create a new message.
 */
export const ChangeCompanyContractPlanRequestSchema: GenMessage<ChangeCompanyContractPlanRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 8);

/**
 * プラン変更の試算（PreviewCompanyContractPlanChange）の結果。入力はChangeCompanyContractPlanRequest。
 * 変更後の契約の数量はChangeCompanyContractPlanと同じ関数（repository.planContractPlanChange）で決めるので、
 * 画面は引き継ぎの規則を持たず、ここに載る事実だけで表示・警告する。DBには書かない
 *
 * @generated from message api_proto.v1.PreviewCompanyContractPlanChangeResponse
 */
export type PreviewCompanyContractPlanChangeResponse = Message<"api_proto.v1.PreviewCompanyContractPlanChangeResponse"> & {
  /**
   * 変更後の実効のアカウント上限（staffcapacity.ContractLimit）。業務管理の契約で上限があるときだけ設定される。
   * 変更先が数量の入力を必須とするプランで上限が決まらない（contract_quantity_missing）ときは未設定
   *
   * @generated from field: optional int64 effective_max_active_staffs = 1;
   */
  effectiveMaxActiveStaffs?: bigint;

  /**
   * 変更後の実効の支払い周期あたり付与クレジット（models.ContractGrantForCycle）。営業支援の契約でだけ設定される。
   * 付与量は現契約から引き継がないので、入力が無ければ変更先プランの標準値（無料は0）
   *
   * @generated from field: optional int64 effective_grant_credits_per_period = 2;
   */
  effectiveGrantCreditsPerPeriod?: bigint;

  /**
   * いまの契約のアカウント上限の上書き値（補正）が、新しい契約へ引き継がれるか
   * （上限を入力せず、同じプランで支払いサイクルだけを変えるとき）
   *
   * @generated from field: bool staff_limit_override_carried = 3;
   */
  staffLimitOverrideCarried: boolean;

  /**
   * いまの契約の上書き値が、変更で消えるか（上限を入力せず、プランを変えるとき）
   *
   * @generated from field: bool staff_limit_override_dropped = 4;
   */
  staffLimitOverrideDropped: boolean;

  /**
   * 変更先が数量の入力を必須とするプランで、その数量が決まらないか（入力も引き継ぎも無い）。真なら変更は入力エラーになる
   *
   * @generated from field: bool contract_quantity_missing = 5;
   */
  contractQuantityMissing: boolean;

  /**
   * プランも支払いサイクルも変わらないか。真なら変更は拒否される
   *
   * @generated from field: bool plan_unchanged = 6;
   */
  planUnchanged: boolean;

  /**
   * いまの契約の周期あたり付与量（契約の値）が、変更で消えるか（付与量を入力しないとき。付与量は現契約から
   * 引き継がないため、変更後はプランの標準値になる）。models.ChangedContractTerms.GrantCreditsDropped
   *
   * @generated from field: bool grant_credits_dropped = 7;
   */
  grantCreditsDropped: boolean;

  /**
   * 変更先のプランが契約の数量を持てるか（ServicePlanItem.accepts_contract_quantityと同じ値）。
   * 偽（営業支援の無料プラン）なら、画面は数量の欄を出さず、値を送らない
   *
   * @generated from field: bool accepts_contract_quantity = 8;
   */
  acceptsContractQuantity: boolean;
};

/**
 * Describes the message api_proto.v1.PreviewCompanyContractPlanChangeResponse.
 * Use `create(PreviewCompanyContractPlanChangeResponseSchema)` to create a new message.
 */
export const PreviewCompanyContractPlanChangeResponseSchema: GenMessage<PreviewCompanyContractPlanChangeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 9);

/**
 * 周期あたり付与量の設定・解除。active な営業支援契約が対象。
 * 監査ログ（contract.grant_credits_update）の対象で、承認ワークフローは経由しない。
 * いまの周期のロットは変えず、次の周期の付与から効く
 *
 * @generated from message api_proto.v1.UpdateCompanyContractGrantCreditsRequest
 */
export type UpdateCompanyContractGrantCreditsRequest = Message<"api_proto.v1.UpdateCompanyContractGrantCreditsRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ULID（対象の契約）
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * 変更後の付与量（1以上`models.MaxGrantCreditsPerPeriod`まで）。未指定=契約の値を外してプランの標準値に戻す
   * （プランが標準の数量を持たない契約では拒否）
   *
   * @generated from field: optional int64 grant_credits_per_period = 3;
   */
  grantCreditsPerPeriod?: bigint;

  /**
   * 変更の理由（必須。監査ログと契約履歴に残す）
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyContractGrantCreditsRequest.
 * Use `create(UpdateCompanyContractGrantCreditsRequestSchema)` to create a new message.
 */
export const UpdateCompanyContractGrantCreditsRequestSchema: GenMessage<UpdateCompanyContractGrantCreditsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 10);

/**
 * アカウント上限の上書き値の設定・解除。監査ログの対象で、承認ワークフローは経由しない（決定89(e)）
 *
 * @generated from message api_proto.v1.UpdateCompanyContractStaffLimitRequest
 */
export type UpdateCompanyContractStaffLimitRequest = Message<"api_proto.v1.UpdateCompanyContractStaffLimitRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ULID（対象の契約。業務管理（crm）契約のみ）
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * 上限の上書き値（単位は人）。未指定＝上書きを解除してプラン標準値に戻す
   *
   * @generated from field: optional int64 max_active_staffs_override = 3;
   */
  maxActiveStaffsOverride?: bigint;

  /**
   * 補正の理由（監査ログに残す）
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyContractStaffLimitRequest.
 * Use `create(UpdateCompanyContractStaffLimitRequestSchema)` to create a new message.
 */
export const UpdateCompanyContractStaffLimitRequestSchema: GenMessage<UpdateCompanyContractStaffLimitRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 11);

/**
 * 即時解約（操作した瞬間に解約済みになる）。未来日で止めるときは ScheduleCompanyContractCancellation を使う
 *
 * @generated from message api_proto.v1.CancelCompanyContractRequest
 */
export type CancelCompanyContractRequest = Message<"api_proto.v1.CancelCompanyContractRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ULID
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;
};

/**
 * Describes the message api_proto.v1.CancelCompanyContractRequest.
 * Use `create(CancelCompanyContractRequestSchema)` to create a new message.
 */
export const CancelCompanyContractRequestSchema: GenMessage<CancelCompanyContractRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 12);

/**
 * 解約の予約（解約予定日の設定・変更）。active な契約が対象。
 * cancel_scheduled_on は操作日以降の日付（契約期間の終了日より後でもよい。その場合は満了時に自動更新され、
 * 次の期間のクレジットが付与されたうえで予定日に解約される）。既に予約があれば上書きする。
 * 監査ログ（contract.cancel_schedule）と契約履歴（cancel_scheduled）に残す。承認ワークフローは経由しない
 *
 * @generated from message api_proto.v1.ScheduleCompanyContractCancellationRequest
 */
export type ScheduleCompanyContractCancellationRequest = Message<"api_proto.v1.ScheduleCompanyContractCancellationRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ULID
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * 解約予定日（YYYY-MM-DD）。この日まで使える
   *
   * @generated from field: string cancel_scheduled_on = 3;
   */
  cancelScheduledOn: string;
};

/**
 * Describes the message api_proto.v1.ScheduleCompanyContractCancellationRequest.
 * Use `create(ScheduleCompanyContractCancellationRequestSchema)` to create a new message.
 */
export const ScheduleCompanyContractCancellationRequestSchema: GenMessage<ScheduleCompanyContractCancellationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 13);

/**
 * 解約予約の取り消し。予約が無い契約には CONTRACT_CANCELLATION_NOT_SCHEDULED を返す。
 * 監査ログ（contract.cancel_unschedule）と契約履歴（cancel_unscheduled）に残す
 *
 * @generated from message api_proto.v1.UnscheduleCompanyContractCancellationRequest
 */
export type UnscheduleCompanyContractCancellationRequest = Message<"api_proto.v1.UnscheduleCompanyContractCancellationRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ULID
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;
};

/**
 * Describes the message api_proto.v1.UnscheduleCompanyContractCancellationRequest.
 * Use `create(UnscheduleCompanyContractCancellationRequestSchema)` to create a new message.
 */
export const UnscheduleCompanyContractCancellationRequestSchema: GenMessage<UnscheduleCompanyContractCancellationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 14);

/**
 * 企業単位の休止（companies.suspended_at）。契約ではなく企業レベルの状態
 *
 * @generated from message api_proto.v1.SuspendCompanyRequest
 */
export type SuspendCompanyRequest = Message<"api_proto.v1.SuspendCompanyRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.SuspendCompanyRequest.
 * Use `create(SuspendCompanyRequestSchema)` to create a new message.
 */
export const SuspendCompanyRequestSchema: GenMessage<SuspendCompanyRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 15);

/**
 * @generated from message api_proto.v1.ResumeCompanyRequest
 */
export type ResumeCompanyRequest = Message<"api_proto.v1.ResumeCompanyRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.ResumeCompanyRequest.
 * Use `create(ResumeCompanyRequestSchema)` to create a new message.
 */
export const ResumeCompanyRequestSchema: GenMessage<ResumeCompanyRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_contract, 16);

